import { connect } from "react-redux";
import { performAction } from "../../../store/actions/all";
import { initBaseData, refreshToken, register } from "../../../store/actions/userActions";
import { AppDispatch, RootState, store } from "../../../store";
import { IDType } from "../../../config/types";
import { SportEnum, UserCreate } from "../../../client/api";
import { fetchLeagues } from "../../../store/actions/leagueActions";
import { LeagueActionTypes, MatchActionTypes, StandingActionTypes } from "../../../store/actions/types";
import { reset as resetAdsState } from "../../../store/ads/adsSlice";
import {
  selectAreaOfInterest,
  selectLanguage,
  selectSportsType,
  selectUserSlice,
  selectUserStatus
} from "../../../selectors";

const mapper = (dispatch: AppDispatch) => ({

  refreshToken: () => {
    performAction({ f: refreshToken, p: [dispatch] });
  },
  createUser: (userCreate: UserCreate) => {
    performAction({ f: register, p: [dispatch, userCreate] });
  },
  getLeagues: (regionId: IDType, sports: SportEnum) => {
    fetchLeagues(dispatch, regionId, sports);
  },
  initBaseDataUser: () => {
    initBaseData(dispatch, store);
  },

  resetStoredData: () => {
    dispatch({ type: MatchActionTypes.RESET });
    dispatch({ type: StandingActionTypes.RESET });
    dispatch({ type: LeagueActionTypes.RESET });
    dispatch(resetAdsState());
  }
});
const props = (
  state: RootState
) => ({
  user: selectUserSlice(state).value,
  error: selectUserSlice(state).error,
  status: selectUserStatus(state),
  languageObject: selectLanguage(state),
  aoi: selectAreaOfInterest(state),
  sports: selectSportsType(state)
});

export const connector = connect(props, mapper);
